// extracted by mini-css-extract-plugin
export default {"loading-overlay":"App_loading-overlay__QRYq9","overlay":"App_overlay__MYRNi"};